import { render, staticRenderFns } from "./RemediationPaymentCallback.vue?vue&type=template&id=6f1c4f72&scoped=true"
import script from "./RemediationPaymentCallback.vue?vue&type=script&lang=js"
export * from "./RemediationPaymentCallback.vue?vue&type=script&lang=js"
import style0 from "./RemediationPaymentCallback.vue?vue&type=style&index=0&id=6f1c4f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1c4f72",
  null
  
)

export default component.exports